
import {createSlice} from '@reduxjs/toolkit'
import { fetchworkorderpaymentTypes } from '../../action/master/workorderpaymentTypesAction'

interface workorderpaymentTypesState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: workorderpaymentTypesState = {
  data: null,
  status: 'idle',
  error: null,
}

const workorderpaymentTypesSlice = createSlice({
  name: 'workorderpaymentTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchworkorderpaymentTypes.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchworkorderpaymentTypes.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchworkorderpaymentTypes.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default workorderpaymentTypesSlice.reducer
